<template>
	<main id="salon">
		<article class="grid h-full sm:grid-cols-2 md:grid-cols-3">
			<section class="flex h-full items-center jusitfy-center sm:col-span-2 md:col-span-1">
				<div class="items-end px-6 lg:px-14 w-full">
					<h1 class="text-5xl lg:text-6xl leading-none mb-9 uppercase">
						Philosophie
					</h1>
					<p class="text-base text-justify mb-9">
						Moderner Familienbetrieb, bei dem ihre Wünsche im Mittelpunkt stehen!
						<br />
						<br />
						Die fachliche Arbeit und individuelle Beratung ist unser Ziel. <br />
						Wertschätzung und Zufriedenheit eines jeden Kunden, macht uns als Team glücklich.
						Unsere offenen und hellen Räumlichkeiten ermöglichen eine entspannte Atmosphäre.
						<br />
						<br />
						<span class="caveat text-2xl text-red-9">
							Von Haar zu Haar eben!
						</span>
					</p>
				</div>
			</section>
			<section class="h-full max-h-screen">
				<img class="object-cover h-full" src="images/salon-3.jpg" alt="Salon - Vollansicht" />
			</section>
			<section class="relative flex flex-col h-full items-center justify-center py-9 md:p-0 w-full">
				<div class="items-center flex flex-col flex-wrap justify-center h-full max-w-4xl relative w-full z-20">
					<div class="h-56 mt-6 md:-mr-64 md:h-64">
						<img class="h-56 md:h-64 object-cover w-56 md:w-64" src="images/salon-4.jpg" alt="Salon - Herrenbereich" />
					</div>
					<div class="h-56 mt-6 md:-ml-64 md:h-64">
						<img class="h-56 md:h-64 object-cover object-bottom w-56 md:w-64" src="images/salon-2.1.jpg" alt="Salon - Waschecke" />
					</div>
					<div class="h-56 mt-6 md:-mr-64 md:h-64">
						<img class="h-56 md:h-64 object-cover w-56 md:w-64" src="images/salon.jpg" alt="Salon - Theke" />
					</div>
				</div>

				<div class="absolute bg-gray-6 center flex h-1/2 px-12 top-0 w-full z-c" />
				<div class="absolute bg-gray-1 bottom-0 center flex h-1/2 px-12 w-full z-c"/>
			</section>
		</article>
	</main>
</template>

<script>
	export default {
		name: 'salon'
	};
</script>
